import React from 'react'
import { Input, InputNumber, Typography } from 'antd'
import PropTypes from 'prop-types'

import { StyledNoMarginFormItem } from '../../../core/components/styled'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormItemLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

const FormInput = ({
  name,
  label,
  rules,
  labelAbove,
  showColon,
  isNumber,
  ...rest
}) => (
  <StyledNoMarginFormItem
    labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    fieldKey={name}
    name={name}
    label={
      <Typography.Text>{formatFormItemLabel(label, showColon)}</Typography.Text>
    }
    rules={rules}
  >
    {isNumber ? <InputNumber {...rest} /> : <Input {...rest} />}
  </StyledNoMarginFormItem>
)

FormInput.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  labelAbove: PropTypes.bool,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  showColon: PropTypes.bool,
  isSearch: PropTypes.bool,
  isTextArea: PropTypes.bool,
  isNumber: PropTypes.bool,
}

FormInput.defaultProps = {
  label: '',
  rules: undefined,
  labelAbove: false,
  showColon: false,
  isSearch: false,
  isTextArea: false,
  isNumber: false,
}

export default FormInput
